export const ExpenditureCreditProviderTypes = [
  {
    value: "BankAccount",
    title: "Bank Account",
  },
  {
    value: "CarInsurance",
    title: "Car Insurance",
  },
  {
    value: "CCJ",
    title: "CCJ",
  },
  {
    value: "Communications",
    title: "Communications",
  },
  {
    value: "CreditCard",
    title: "Credit Card",
  },
  {
    value: "Default",
    title: "Default",
  },
  {
    value: "DefaultedSecured",
    title: "Defaulted Secured",
  },
  {
    value: "EXLoan",
    title: "EX Loan",
  },
  {
    value: "FlexibleMortgage",
    title: "Flexible Mortgage",
  },
  {
    value: "HirePurchase",
    title: "Hire Purchase",
  },
  {
    value: "Loan",
    title: "Loan",
  },
  {
    value: "Mortgage",
    title: "Mortgage",
  },
  {
    value: "Overdraft",
    title: "Overdraft",
  },
  {
    value: "PaydayLoan",
    title: "Payday Loan",
  },
  {
    value: "PublicUtility",
    title: "Public Utility",
  },
  {
    value: "Rent",
    title: "Rent",
  },
  {
    value: "RetailCredit",
    title: "Retail Credit",
  },
  {
    value: "SecuredLoan",
    title: "Secured Loan",
  },
  {
    value: "Other",
    title: "Other",
  },
];
